import { render, staticRenderFns } from "./PackageSize.vue?vue&type=template&id=3ddb2b67"
import script from "./PackageSize.vue?vue&type=script&lang=js"
export * from "./PackageSize.vue?vue&type=script&lang=js"
import style0 from "./PackageSize.vue?vue&type=style&index=0&id=3ddb2b67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports